const match = (matchValue, displayName) => (value) => (
  (value === matchValue) || `${displayName} must Match`
)

export default match
